import { get } from "./api";
import URLS from "../constants/api";

export const getUserProfile = async (
) => {

  const response = await get(URLS.GET_USER_PROFILE);
  return response;
};
